import React from 'react';
import { getColorDependsOnBackground } from '../../main/utils/helpers/getColorDependsOnBackground';

const ContactUs = ({
  locales: { portfolioWeb },
  data: { title, emailOrWebsite, description, fullName },
  backgroundSection,
  isFourthColorPaletteNumber = false,
}) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  const textColorDependsOnBackground =
    isFourthColorPaletteNumber &&
    getColorDependsOnBackground(backgroundSection);

  return (
    <div
      className="contact-us-blogFriendly-web"
      style={{ backgroundColor: backgroundSection }}
    >
      <div className="header">
        <div
          className="blogFriendly-title title custom-font-title"
          style={{ color: textColorDependsOnBackground }}
        >
          {portfolioWeb.contactUs.title}
        </div>
        <div>
          <button
            className="scroll-top custom-font-body"
            style={{
              backgroundColor: backgroundSection,
              color: textColorDependsOnBackground,
            }}
            onClick={scrollToTop}
          >
            {portfolioWeb.contactUs.scrollTop}
            <i className="icon-Arrow-Top" />
          </button>
        </div>
      </div>
      <div className="fields">
        <div
          className="description custom-font-body"
          style={{ color: textColorDependsOnBackground }}
        >
          {description}
        </div>
        <div
          className="form-field custom-font-body"
          style={{ color: textColorDependsOnBackground }}
        >
          {fullName}
        </div>
        <div
          className="form-field email custom-font-body"
          style={{ color: textColorDependsOnBackground }}
        >
          {emailOrWebsite}
        </div>
      </div>

      <div
        className="footer custom-font-body"
        style={{
          color: textColorDependsOnBackground,
          borderColor: textColorDependsOnBackground,
        }}
      >
        <div className="left ">
          {`© ${title}. ${portfolioWeb.contactUs.rightsReserve}`}
        </div>
        <div className="right">
          {portfolioWeb.contactUs.buildCreate}
          <span
            className="company-name"
            style={{ color: textColorDependsOnBackground }}
          >
            {portfolioWeb.contactUs.companyName}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
